import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Group } from '@frontend/sports/grid/core/feature/model';

@Component({
    selector: 'ms-group-header',
    templateUrl: './group-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupHeaderComponent {
    @Input() group: Group;
    @Input() overriddenHeaderName?: string;

    @HostBinding('class') className = 'grid-group grid-group-heading';

    @HostBinding('class.single')
    get singleGroupHeader() {
        return !!this.overriddenHeaderName;
    }
}
